// Global UI Action
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const OPEN_SUBMENU = 'OPEN_SUBMENU';
export const CHANGE_THEME = 'CHANGE_THEME';
export const LOAD_PAGE = 'LOAD_PAGE';

// Tree Table
export const TOGGLE_TREE = 'TOGGLE_TREE';

// Redux Form Sample
export const INIT = 'INIT';
export const CLEAR = 'CLEAR';

// Crud Table
export const FETCH_DATA = 'FETCH_DATA';
export const ADD_EMPTY_ROW = 'ADD_EMPTY_ROW';
export const UPDATE_ROW = 'UPDATE_ROW';
export const REMOVE_ROW = 'REMOVE_ROW';
export const EDIT_ROW = 'EDIT_ROW';
export const SAVE_ROW = 'SAVE_ROW';

// Ecommerce
export const FETCH_PRODUCT_DATA = 'FETCH_PRODUCT_DATA';
export const SEARCH_PRODUCT = 'SEARCH_PRODUCT';
export const SHOW_DETAIL_PRODUCT = 'SHOW_DETAIL_PRODUCT';
export const ADD_TO_CART = 'ADD_TO_CART';
export const DELETE_CART_ITEM = 'DELETE_CART_ITEM';
export const CHECKOUT = 'CHECKOUT';

// Contact
export const FETCH_CONTACT_DATA = 'FETCH_CONTACT_DATA';
export const SHOW_DETAIL_CONTACT = 'SHOW_DETAIL_CONTACT';
export const HIDE_DETAIL = 'HIDE_DETAIL';
export const ADD_CONTACT = 'ADD_CONTACT';
export const EDIT_CONTACT = 'EDIT_CONTACT';
export const SUBMIT_CONTACT = 'SUBMIT_CONTACT';
export const CLOSE_CONTACT_FORM = 'CLOSE_CONTACT_FORM';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const TOGGLE_FAVORITE = 'TOGGLE_FAVORITE';
export const SEARCH_CONTACT = 'SEARCH_CONTACT';

// Calendar
export const FETCH_CALENDAR_DATA = 'FETCH_CALENDAR_DATA';
export const ADD_EVENT = 'ADD_EVENT';
export const DISCARD_EVENT = 'DISCARD_EVENT';
export const SUBMIT_EVENT = 'SUBMIT_EVENT';
export const DELETE_EVENT = 'DELETE_EVENT';

// Notification Form
export const CLOSE_NOTIF = 'CLOSE_NOTIF';

// date
export const ACTIVE_MONTH = 'ACTIVE_MONTH';

//compaign
export const COMPAIGN = 'COMPAIGN';

//login
export const LOGIN = 'LOGIN';
//logout
export const LOGOUT = 'LOGOUT';

//alert
export const ALERT = 'ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// increament
export const COUNTER = 'COUNTER';